
import { assetDataService } from '../../../../../../../../services/data/asset.data.service';

export default function uniqueAssetTypeNameDirective(
  $q,
  assetDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const assetTypeId = attributes.assetTypeId || -1;
    ngModel.$asyncValidators.emFunctionVendorUniqueName = modelValue => assetDataService
      .checkCustomerAssetTypeExists(assetTypeId, modelValue).then((response) => {
        const nameExists = response.data.result;
        if (!nameExists) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'emAssetTypeUniqueName';

uniqueAssetTypeNameDirective.$inject = [
  '$q',
  'assetDataService',
];
